export default __webpack_public_path__ + "static/media/berny-artworkinfo3.76d3cbd2.png";